import { Directive, Input } from '@angular/core';
import { Validator, AbstractControl, NG_VALIDATORS, ValidatorFn, ValidationErrors } from '@angular/forms';
import { AppConsts } from '@shared/AppConsts';

export function emptyOrExactLengthValidator(length: number): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } | null => {
        if (control.value == null)
            return null;
        var input = control.value.toString();
        var empty = input.length == 0;
        var exactLength = input.length == length;
        const restricted = !(empty || exactLength);
        return restricted ? { 'emptyOrExactLength': { value: control.value } } : null;
    };
}

@Directive({
    selector: '[emptyOrExactLength]',
    providers: [{ provide: NG_VALIDATORS, useExisting: EmptyOrExactLengthValidator, multi: true }]
})
export class EmptyOrExactLengthValidator implements Validator {

    @Input("emptyOrExactLength")
    exactLength: number;


    validate(control: AbstractControl): ValidationErrors {
        return emptyOrExactLengthValidator(this.exactLength)(control);
    }
}
